import React, { useContext, useEffect, useState } from "react";
import { Page, Text, View, Document, StyleSheet, Image } from "@react-pdf/renderer";
import QRCode from "qrcode";
import { OrderType } from "../../../interfaces/delivery-company/orders";
import { get_cod } from "../../../utils/cod";
import { displayMoney, isNonZero } from "../../../utils/money";
import { format } from "date-fns";
import { displayLocation } from "../../../utils/locations";
import { Workflow } from "../../../enums/orders";
import { encodePermanentPackage } from "../../../utils/encoding";
import { registerFonts } from "../../../utils/pdf-fonts";
import { display_phone_number } from "../../../utils/phone_numbers";
import { color } from "framer-motion";
import merchant from "../../delivery-company-components/merchant/merchant";
import { defaultMerchantReportFieldsConfig, defaultMerchantFooter, defaultReturnReportFieldsConfig, defaultMerchantReturnFooter } from "../report-builder/fields-config";
import { ReportProps, Table, IFieldConfig, IFooterRow, MultiReportDocument } from "../report-builder/report";
import { Alert } from "@mui/material";

registerFonts();


const getMerchantReportDocProps = (orders: OrderType[], orgId: string, color: string, printDate: Date): ReportProps<OrderType> => {

    return {
        color: color,
        tables: [{
            items: orders,
            fields_config: defaultReturnReportFieldsConfig as IFieldConfig<OrderType>[],
            header_bg: '#eee',
            title: "Returned Orders",
            table_footer_rows: defaultMerchantReturnFooter as IFooterRow<OrderType>[],
        }],
        subtitles: [`Merchant: ${orders[0].merchant?.name} / ${orders[0]?.merchant?.phone_number}`, `Deferred Payment`],
        organisation_id: orgId,
        date_from: format(
            printDate,
            'dd-MM-yyyy'
        ),
        date_to: format(
            printDate,
            'dd-MM-yyyy'
        ),
        title: `Return Statement`,
    };
}


const ReturnStatements = ({ orders, orgId, color }: { orders: OrderType[], orgId: string, color: string }) => {
    const printDate = new Date();
    const groupedByMerchant = new Map<string, OrderType[]>()


    orders.filter(item => item.workflow === Workflow.RETURN).forEach(item => {
        if (item.merchant)
            groupedByMerchant.has(item.merchant.id) ? groupedByMerchant.get(item.merchant.id)?.push(item) : groupedByMerchant.set(item.merchant.id, [item])
        else {
            throw new Error("merchant is null in return statement generator")
        }
    })

    const reportsProps = Array.from(groupedByMerchant.values()).filter(orders => orders.length > 0).map(orders => orders.sort((a, b) => parseInt(a.order_id) < parseInt(b.order_id) ? -1 : 1)).map(orders => getMerchantReportDocProps(orders, orgId, color, printDate))
    return reportsProps.length === 0 ? <Document><Page><View><Text>Selected orders contain no returned orders.</Text></View></Page></Document> : <MultiReportDocument reportsProps={reportsProps} />
};

export default ReturnStatements